import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  InputBase,
  Popover,
  Divider,
  Link,
  Avatar
} from "@mui/material";
import { FaBell } from "react-icons/fa";
import { Search, AccountCircle, Menu as MenuIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getAllNotifications , markAllNotiAsRead } from "../../reducers/legalteamNotificationReducer";


const LegalTeamHeader = ({ onDrawerToggle }) => {
  const avatar=useSelector((state)=>state.user.avatar);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userId = useSelector((state) => state.user.userId);
  const notifications = useSelector((state) => state.notification.list);
  const unReadNotifications = notifications.filter(notification => notification.status === 'Unread');
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    if (userId) {
      dispatch(getAllNotifications(userId));
    }
  }, [dispatch, userId]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMarkAllAsRead = async () => {
    if (userId) {
      await dispatch(markAllNotiAsRead(userId));
    }
  };

  const handleNotificationClick = (notification) => {
    navigate("/legalteamnotificationdetails", {
      state: {
        notificationId: notification.id,
        notifications: [notification],
      },
    });
    handleClose();
  };

  const handleProfileClick = () => {
    navigate("/ProfilePage");
  };

  const unreadCount = notifications.filter((n) => n.status === "Unread").length;

  const open = Boolean(anchorEl);
  const id = open ? "notification-popover" : undefined;

  return (
    <AppBar position="sticky" sx={{ backgroundColor: "#ffffff", color: "#333" }}>
      <Toolbar>
        {/* Hamburger Menu */}
        <IconButton edge="start" onClick={onDrawerToggle} sx={{ display: { sm: "none" } }}>
          <MenuIcon />
        </IconButton>

        {/* Logo */}
        <Typography variant="h6" sx={{ flexGrow: 1, color: "green", fontWeight: "bold" }}>
          RealEstate
        </Typography>

        {/* Search */}
        <Box
          sx={{
            backgroundColor: "#f1f3f4",
            borderRadius: 2,
            paddingX: 1,
            marginRight: 2,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Search />
          <InputBase placeholder="Search…" sx={{ marginLeft: 1, flex: 1 }} />
        </Box>

        {/* Notifications */}
        <div className="notification-area">
          <IconButton
            aria-describedby={id}
            onClick={handleClick}
            className="notification__icon"
            sx={{ position: "relative" }}
          >
            <FaBell />
            {unreadCount > 0 && (
              <Box
                sx={{
                  position: "absolute",
                  top: -5,
                  right: -5,
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "50%",
                  minWidth: 20,
                  height: 20,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "0.75rem",
                }}
              >
                {unreadCount}
              </Box>
            )}
          </IconButton>

          {/* Notification Popover */}
          <Popover
            id="notification-popover"
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <Box sx={{ width: 300 }}>
              {/* Header */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  backgroundColor: "#0c266c",
                  padding: "12px 20px",
                  borderRadius: "10px 10px 0 0",
                }}
              >
                <Typography variant="h6" sx={{ color: "#fff", fontSize: "16px" }}>
                  {unreadCount} New Notifications
                </Typography>
                <Link
                  underline="hover"
                  sx={{ color: "#ffffff", fontSize: "0.85rem", cursor: "pointer" }}
                  onClick={() => {
                    handleClose();
                    navigate("/notifications", { state: { notifications } });
                  }}
                >
                  View All
                </Link>
              </Box>

              <Divider />

              {/* Notification List */}
              <Box
                sx={{
                  maxHeight: 300,
                  overflowY: "auto",
                  background: "#5927e3",
                  padding: "10px 20px",
                }}
              >
                {unReadNotifications.length === 0 ? (
                  <Typography variant="body2" color="#fff">
                    No unread notifications available.
                  </Typography>
                ) : (
                  unReadNotifications.map((notification) => (
                    <Box
                      key={notification.Id}
                      onClick={() => handleNotificationClick(notification)}
                      sx={{
                        marginTop: "15px",
                        padding: "8px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "#4a20c0" },
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body1" fontWeight="bold" sx={{ color: "#fff" }}>
                          {notification.title}
                        </Typography>
                        <Typography variant="caption" sx={{ color: "#fff", marginLeft: 2 }}>
                          {new Date(notification.created_at).toLocaleString()}
                        </Typography>
                      </Box>
                    </Box>
                  ))
                )}
              </Box>

              {/* Footer */}
              <Link
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleMarkAllAsRead();
                  handleClose();
                }}
                sx={{
                  padding: "12px 20px",
                  textAlign: "center",
                  color: "#fff",
                  fontSize: "16px",
                  backgroundColor: "#0c266c",
                  display: "block",
                  borderRadius: "0 0 10px 10px",
                  cursor: "pointer",
                }}
              >
                Mark all as read
              </Link>
            </Box>
          </Popover>
        </div>

        {/* Profile */}
        <IconButton onClick={handleProfileClick}>
      {avatar ? (
        <Avatar alt="Profile Avatar" src={avatar} sx={{width:24,height:24}} />
      ) : (
        <AccountCircle />
      )}
    </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default LegalTeamHeader;
